import script from "./LessonPracticeHistory.vue?vue&type=script&setup=true&lang=ts"
export * from "./LessonPracticeHistory.vue?vue&type=script&setup=true&lang=ts"

import "./LessonPracticeHistory.vue?vue&type=style&index=0&id=2147326e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2147326e"]])

export default __exports__